import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401) {
        // auto logout if 401 response returned from api
        this.authService.logout();
        location.reload(true);
      }

      // Preservar toda la información del error para debugging
      console.error('Error interceptor capturó:', err);
      
      // Para errores 422, preservar toda la información
      if (err.status === 422) {
        return throwError(err);
      }
      
      // Para otros errores, mantener el comportamiento original pero con más información
      const error = {
        status: err.status,
        statusText: err.statusText,
        message: err.error?.message || err.statusText,
        error: err.error,
        url: err.url,
        headers: err.headers
      };
      
      return throwError(error);
    }))
  }

}
